// Confirmación tras crear un Delivery manual -- ver "LYNX — unificación
// External API/Admin/Seller", punto 4/10. Mismos tokens visuales que el
// resto de la app (var(--surface)/var(--border)/etc, mismo patrón overlay
// que ya usan los demás modales de detalle) -- no existía un <Modal>
// genérico para extender, así que este queda como la base reutilizable
// entre Admin y Seller (ambos lo importan, ninguno lo reimplementa).
//
// Imprimir reutiliza printPackageLabel() tal cual -- nunca genera una
// etiqueta nueva acá. Si cantidad_bultos > 1, printPackageLabel ya trae
// las N páginas (ver labelSvgPages en labelPrint.ts): un solo click
// imprime todos los bultos.
import React, { useState } from "react";
import Button from "../ui/Button";
import { printPackageLabel } from "../../lib/packageLabel";
import type { DeliveryCreatedResult } from "./DeliveryIntakeForm";

const overlayStyle: React.CSSProperties = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
  display: "flex", alignItems: "center", justifyContent: "center",
  zIndex: 1000, padding: "16px",
};

const cardStyle: React.CSSProperties = {
  background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "20px",
  padding: "28px", maxWidth: "420px", width: "100%",
  boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
};

const titleStyle: React.CSSProperties = { margin: "0 0 4px", fontSize: "20px", fontWeight: 800, color: "var(--text-primary)" };
const subtitleStyle: React.CSSProperties = { margin: "0 0 20px", fontSize: "14px", color: "var(--success, #16a34a)", fontWeight: 600 };
const rowStyle: React.CSSProperties = { display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid var(--border)", fontSize: "14px" };
const labelStyle: React.CSSProperties = { color: "var(--text-secondary)" };
const valueStyle: React.CSSProperties = { color: "var(--text-primary)", fontWeight: 700, textAlign: "right" };
const actionsStyle: React.CSSProperties = { display: "flex", gap: "12px", marginTop: "22px" };
const errorStyle: React.CSSProperties = { marginTop: "12px", fontSize: "13px", color: "var(--danger)" };

export default function DeliveryCreatedModal({
  result,
  token,
  onClose,
}: {
  result: DeliveryCreatedResult;
  token: string | null;
  onClose: () => void;
}) {
  const [printing, setPrinting] = useState(false);
  const [printError, setPrintError] = useState("");

  const handlePrint = async () => {
    setPrinting(true);
    setPrintError("");
    try {
      await printPackageLabel(result.deliveryID, { token, scope: "deliveries" });
    } catch (err) {
      setPrintError(err instanceof Error ? err.message : "No se pudo imprimir la etiqueta");
    } finally {
      setPrinting(false);
    }
  };

  return (
    <div style={overlayStyle} role="dialog" aria-modal="true">
      <div style={cardStyle}>
        <h2 style={titleStyle}>Envío cargado correctamente</h2>
        <p style={subtitleStyle}>
          {result.cantidadBultos > 1 ? `${result.cantidadBultos} bultos listos para imprimir` : "Listo para imprimir"}
        </p>

        <div>
          <div style={rowStyle}><span style={labelStyle}>Destinatario</span><span style={valueStyle}>{result.nombreDestinatario}</span></div>
          <div style={rowStyle}><span style={labelStyle}>Lynx code</span><span style={valueStyle}>{result.lynxCode}</span></div>
          <div style={rowStyle}><span style={labelStyle}>Store</span><span style={valueStyle}>{result.storeName}</span></div>
          <div style={{ ...rowStyle, borderBottom: "none" }}><span style={labelStyle}>Account</span><span style={valueStyle}>{result.accountName}</span></div>
        </div>

        {printError ? <div style={errorStyle}>{printError}</div> : null}

        <div style={actionsStyle}>
          <Button type="button" variant="secondary" onClick={onClose} style={{ flex: 1 }}>
            Cerrar
          </Button>
          <Button type="button" variant="primary" onClick={handlePrint} disabled={printing} style={{ flex: 1 }}>
            {printing ? "Imprimiendo..." : "Imprimir etiqueta"}
          </Button>
        </div>
      </div>
    </div>
  );
}
